import "./spiner.css";

export function Spiner({ progress, napis }) {
	const listki = 10;
	const divy = [];

	const createDiv = () => {
		for (let i = 1; i <= listki; i++) {
			divy.push(<div className={`listki listek${i}`} key={i}></div>);
		}
		return divy;
	};

	return (
		<>
			<div className="loading">
				<div className="divContainerSpiner">{createDiv()}</div>
				<div className="LoadingTextDiv">
					{!napis && <p className="loadingText">Loading</p>}
					{progress && <p className="loadingProgress">{progress}%</p>}
				</div>
			</div>
		</>
	);
}

export function SmallSpiner({ progress }) {
	const listki = 10;
	const divy = [];

	const createDiv = () => {
		for (let i = 1; i <= listki; i++) {
			divy.push(<div className={`listkiSmall listek${i}Small`} key={i}></div>);
		}
		return divy;
	};

	return (
		<>
			<div className="loadingSmall">{createDiv()}</div>
			<div className="LoadingTextDivSmall">
				<p className="loadingTextSmall">Loading</p>
				{progress && <p className="loadingProgressSmall">{progress}%</p>}
			</div>
		</>
	);
}
